/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2022-12-07 09:53:03
 * @Description: 
 */
import { Tooltip } from "antd";
import { TooltipPlacement } from "antd/lib/tooltip";
import clsx from "clsx";
import React from "react"
import FTAnalytic from "src/analyze/FTAnalytic";
import { IconCompare } from "src/assets";
import FTCanvasStore from "src/store/FTCanvasStore";
import FTLang from "src/utils/FTLang";
import "./index.scss"
interface Iprops {
  needToolTip: boolean;
  theme: "dark" | "light"
  placement?: TooltipPlacement;
}
export default function FTimageCompare(props: Iprops) {
  let { needToolTip, theme = "dark", placement = "left" } = props
  const handleCompare = (bool: boolean) => {
    // 如果为true 进行对比操作
    // 如果为 fakse 取消对比
    FTAnalytic.addAnalytic({
      type: 'ev',
      analyticType: "sa",
      action: 'fotor_web$click_up$goart_project_effects',
      label: {
        resource_id: "compare",
        resource_name: "compare",
      }
    })
    FTCanvasStore.compare(bool)
  }
  return <div
    className={clsx("ai_image_compare", theme)}
    onMouseDown={() => handleCompare(true)}
    onMouseUp={() => handleCompare(false)}
    onTouchStart={() => handleCompare(true)}
    onTouchEnd={() => handleCompare(false)}
  >
    {needToolTip ? <Tooltip key="image_compare_tip" placement={placement} color="#FFFFFF" overlayClassName="ai_image_common_operate_tip" title={FTLang._("goart_compare_tip")}>
        <div className="ai_image_common">
          <IconCompare />
        </div>
      </Tooltip> : <IconCompare key="image_compare" />}
  </div>
}